const Factory = (accessToken: string) => ({
  headers: {
    'X-Auth-Token': accessToken,
  },
});

export default Factory;
